const adminLiveRouter = [
  {
    path: '/admin/live',
    name: 'AdminLiveIndex',
    component: () => import('@/views/admin/live/index')
  },
  {
    path: '/admin/live/create',
    name: 'AdminLiveCreate',
    component: () => import('@/views/admin/live/create')
  },
  {
    path: '/admin/live/edit',
    name: 'AdminLiveEdit',
    component: () => import('@/views/admin/live/edit')
  },
  {
    path: '/admin/live/link',
    name: 'AdminLiveLink',
    component: () => import('@/views/admin/live/link')
  },
  {
    path: '/admin/live/manager',
    name: 'AdminLiveManager',
    component: () => import('@/views/admin/live/manager')
  },
  {
    path: '/admin/live/viewer',
    name: 'AdminLiveViewer',
    component: () => import('@/views/admin/live/viewer')
  }
]

export default adminLiveRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/live.js